import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { RouteReuseStrategy, TitleStrategy } from '@angular/router';

import { AppTitleStrategy } from './app-title.strategy';
import { CustomRouteReuseStrategy } from './route-reuse-strategy';

/** Кастомная стратегия переиспользования маршрутов (кэш по `route.data['reuse']`). */
export function provideCustomRouteReuse(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
  ]);
}

/** Стратегия заголовков: синхронизирует <title> и og:title с префиксом форума. */
export function provideAppTitleStrategy(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: TitleStrategy, useClass: AppTitleStrategy },
  ]);
}
